<script>
    export let title = null
    export let subtitle = null
    export let closeable = true
    export let style = ''
    export let justifyButtons = 'flex-end'
    export let scrolleable = true
    import { CloseCircle } from '../Icons'
    import { Typography } from '.'
    import { Svrollbar } from 'svrollbar'
    import { fly } from 'svelte/transition'
    import { createEventDispatcher } from 'svelte'
    import { clickOutside } from '$lib/utils'
    const dispatch = createEventDispatcher()
    function onClose() {
        dispatch('close')
    }
    function onClickOut() {
        dispatch('clickout')
    }
    let viewport
    let contents
    let size = {}
</script>

<div
    bind:clientHeight={size.height}
    transition:fly={{ y: 50, duration: 500 }}
    use:clickOutside
    on:clickout={onClickOut}
    class="modal"
    {style}
>
    {#if closeable}
        <span class="close" on:click={onClose}>
            <CloseCircle color="#6E6F71" size={24} title="Cerrar ventana" />
        </span>
    {/if}
    {#if title}
        <Typography style="margin: 0" type="h4">{title}</Typography>
    {/if}
    {#if subtitle}
        <Typography style="margin: 0" type="body" color="grey-800"
            >{subtitle}</Typography
        >
    {/if}
    {#if $$slots.default}
        {#if scrolleable}
            <div
                class="viewport"
                bind:this={viewport}
                style={`width:100% ;margin: 32px 0 ${$$slots.buttonSet ? '0' : '40px'}  0;`}
            >
                <div bind:this={contents} style="scroll-behavior: smooth;">
                    <slot scrollControl={contents} />
                </div>
            </div>
            <span style="position: absolute; top: 135px; right: 0px">
                <Svrollbar {viewport} {contents} alwaysVisible />
            </span>
        {:else}
            <slot scrollControl={contents} />
        {/if}
    {/if}
    {#if $$slots.buttonSet}
        <span
            style="margin: 24px 0 0 0; position: relative; width: 100%; display: flex; flex-direction: columns; justify-content: flex-end; gap: 16px"
        >
            <slot
                name="buttonSet"
                style={`justify-content: ${justifyButtons}`}
            />
        </span>
    {/if}
</div>

<style>
    div.modal {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 40px;
        gap: 8px;
        width: 618px;
        /* height: 342px; */
        max-height: 100%;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: var(--shadow-bottom-bar);
    }
    span.close {
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 40px;
    }
    .viewport {
        position: relative;
        /* width: 10rem;
    height: 10rem; */
        overflow: scroll;
        /* border: 1px solid gray; */
        /* box-sizing: border-box; */

        /* hide scrollbar */
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    /* .contents {} */
    .viewport::-webkit-scrollbar {
        /* hide scrollbar */
        display: none;
    }
</style>
